

















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BusinessCardComponent from '@/profile/components/business-card.component.vue';
import Rep from '@/_shared/entities/rep/rep.entity';
import BusinessPartnerInfoService from '@/profile/business-partner-info/services/business-partner-info.service';
import RepTerms from '@/profile/business-partner-info/entities/rep-terms.entity';
import UplineBps from '@/profile/business-partner-info/entities/upline-bps.inteface';
import PayoutMethod from '@/profile/business-partner-info/entities/payout-methods.interface';
import PayoneerData from '@/profile/business-partner-info/entities/payoneer-data.interface';
import RepConsumptionData from '@/profile/business-partner-info/entities/rep-consumption.interface';
import ReportsAllowedService from '@/_shared/services/reportsAllowed/reports-allowed.service';
import InterruptService from '@/_shared/services/interrupt/interrupt.service';
import Interrupt from '@/_shared/entities/interrupt/interrupt.entity';
import interruptsStatus from '@/_shared/constants/interrupts-status';

@Component({
  components: {
    BusinessCardComponent,
  },
})
export default class BusinessPartnerInfoView extends Vue {
  private repData: RepTerms | null = null;
  private uplineData: UplineBps | null = null;
  private payoutMethod: PayoutMethod | null = null;
  private consumptionData: RepConsumptionData | null = null;
  private payoneerData: PayoneerData | null = null;
  private hasFinishedLoading = false;
  private interrupts: Interrupt[] = [];

  private shopAsACustomerLink = '';

  get rep(): Rep { return this.$store.state.RepStore.rep; }

  get showUplines(): boolean {
    if (!this.uplineData) return false;
    const hasPlacement = this.uplineData.placement && ReportsAllowedService.isAllowed('bp_information_upline_placement');
    const hasSponsor = !!this.uplineData.sponsor;
    return hasPlacement || hasSponsor;
  }

  get supportLink() {
    return process.env.VUE_APP_SUPPORT_KYANI;
  }

  get isPayoneerAllowed() {
    return ReportsAllowedService.isAllowed('payoneer');
  }

  get showShopAsCustomerButton(): boolean {
    return this.hasCustomerAccount;
  }

  get shouldAccessSap(): boolean {
    return this.$store.getters.isCustomerShopSap;
  }

  get hasPayoneerData() {
    return !!this.payoneerData;
  }

  get hasCustomerAccount() {
    return !!this.consumptionData?.consumption;
  }

  get repLinks(): any {
    const interrupts = this.interrupts.map((interrupt) => ({
      id: interrupt.interruptId,
      route: interrupt.document.location,
      title: this.$t(interrupt.type.titleKey).toString(),
    }));
    interrupts.sort((first, second) => first.title.localeCompare(second.title));
    return interrupts;
  }

  private async created(): Promise<void> {
    await this.$store.dispatch('showLoading');
    try {
      await this.retrieveData();
      await this.getConsumptionAccountLink();
    } catch (e) {
      this.payoneerData = null;
    }
    this.$emit('done-loading');
    this.hasFinishedLoading = true;
    await this.$store.dispatch('hideLoading');
  }

  private async retrieveData() {
    const [
      interrupts,
      repData,
      uplineData,
      payoutMethod,
      consumptionData,
      payoneerData,
    ] = await Promise.all([
      InterruptService.getUserInterrupts(interruptsStatus.InterruptStatusAgreed, false, true),
      BusinessPartnerInfoService.retrieveRepTerms(this.rep.did),
      BusinessPartnerInfoService.getUpline(this.rep.did),
      BusinessPartnerInfoService.getPayoutMethod(this.rep.did),
      BusinessPartnerInfoService.getDistributorConsumption(this.rep.did),
      BusinessPartnerInfoService.getPayoneer(this.rep.did),
    ]);
    this.interrupts = interrupts;
    this.repData = repData;
    this.uplineData = uplineData;
    this.payoutMethod = payoutMethod;
    this.consumptionData = consumptionData;
    this.payoneerData = payoneerData;
  }

  private async getConsumptionAccountLink() {
    return BusinessPartnerInfoService.updateSession('rep to customer').then((response) => {
      const customerGUID = response.bdtGuid;
      this.shopAsACustomerLink = this.createShopLink(customerGUID, this.rep.did);
      BusinessPartnerInfoService.updateSession('customer to rep');

      if (this.consumptionData?.consumption_id === null) {
        this.consumptionData = Object.assign(this.consumptionData, {
          // eslint-disable-next-line @typescript-eslint/camelcase
          consumption_id: response.customer,
        });
      }
    });
  }

  private createConsumptionAccount(): Promise<void> {
    this.$store.dispatch('showLoading');
    return BusinessPartnerInfoService.createDistributorConsumptionAccount(this.rep.did)
      .then((data) => {
        this.consumptionData = Object.assign(
          this.consumptionData, {
            consumption: true,
            // eslint-disable-next-line @typescript-eslint/camelcase
            consumption_id: data.customerDID,
          },
        );

        this.shopAsACustomerLink = this.createShopLink(data.customerDID, this.rep.did);
        this.$forceUpdate();
        this.$store.dispatch('hideLoading');
      });
  }

  private createShopLink(guid: string, repDid: number): string {
    const countryCode = this.$store.getters.userShippingCountry?.code;
    if (this.shouldAccessSap) {
      const URL = process.env.VUE_APP_SAP_SHOP_URI;
      return `${URL}/${countryCode}?pca=1`;
    }
    return `${process.env.VUE_APP_SHOP_BDT}/#/seamless/customerbyguid/${guid}/${repDid}`;
  }
}
